<template>
  <div>
    <v-select
        :options="leaders"
        :getOptionLabel="l => l.leader.member? `${l.leader.member.surName} ${l.leader.member.firstName}`: l.leader.associateName"
        v-model="leader"
        @input="getLeaderEvaluationCriteria"
        class="bg-white rounded"
        placeholder="Επιλέξτε Εκπαιδευτή"
        style="margin-bottom: 2em;"
    >
      <template #option="{ leader, evaluationsCount, criteriaCount }">
        <b-icon :icon="evaluationsCount/criteriaCount===0? 'circle': evaluationsCount/criteriaCount===1? 'check-circle-fill': 'circle-half'"
                :variant="evaluationsCount/criteriaCount===0? 'danger': evaluationsCount/criteriaCount===1? 'success': 'warning'"
                style="margin-right: 0.5em"
        ></b-icon>
        {{ leader.member? `${leader.member.surName} ${leader.member.firstName}`: leader.associateName}}
      </template>

      <template #selected-option="{ leader, evaluationsCount, criteriaCount }">
        <b-icon :icon="evaluationsCount/criteriaCount===0? 'circle': evaluationsCount/criteriaCount===1? 'check-circle-fill': 'circle-half'"
                :variant="evaluationsCount/criteriaCount===0? 'danger': evaluationsCount/criteriaCount===1? 'success': 'warning'"
                style="margin-right: 0.5em"
        ></b-icon>
        {{ leader.member? `${leader.member.surName} ${leader.member.firstName}`: leader.associateName}}
      </template>

    </v-select>
    <EvaluationCriteriaList :criteriaList="leaderCriteria" v-on:save.capture="updateLeaderEvaluationValues" :can-submit="canSubmit"/>
  </div>
</template>
<script>
import EvaluationCriteriaList from "@/components/evaluations/EvaluationCriteriaList"
import trainingService from "@/services/training.service";
import {makeErrorToast, makeToast} from "@/services/error.service";

export default {
  name: 'trainerEvaluation',
  components: {EvaluationCriteriaList},
  props: {
    activity: Object,
    leaders: Array,
    canSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leaderCriteria: [],
      leader: null,
    }
  },
  methods: {
    getLeaderEvaluationCriteria(leader) {
      trainingService.getLeaderEvaluation(this.activity.id, leader.leader.id).then(
          (response) => {
            this.leaderCriteria = response.data;
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      )
    },
    updateLeaderEvaluationValues(data) {
      trainingService.updateLeaderEvaluationValues(this.activity.id, this.leader.leader.id, data).then(
          () => {
            makeToast(this.$bvToast, "Επιτυχής αποθήκευση");
            this.$emit('updateEvals');
            this.leader.evaluationsCount = data.reduce((accumulator, object) => {return accumulator + (object.evaluationValue!== null); }, 0);
          },
          (error) => {
            makeErrorToast(this.$bvToast, error);
          }
      )
    }

  }
}
</script>